import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import LoaderStyle from "./useBackdrop.module.css"


const useBackdrop = () => {
  const [open, setOpen] = useState(false);

  const openBackdrop = () => {
    setOpen(true);
  };

  const closeBackdrop = () => {
    setOpen(false);
  };

  const BackdropComponent = () => (
    <Backdrop
      sx={{ color: '#fff', zIndex: "9999999"}}
      open={open}

    >
      {/* <CircularProgress color="inherit" /> */}
      <div className={LoaderStyle.dotSpinner}>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
        <div className={LoaderStyle.dotSpinner__dot}></div>
      </div>
    </Backdrop>
  );

  return { openBackdrop, closeBackdrop, BackdropComponent };
}

export default useBackdrop